import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const resetInternalRequestAuthApi = async (): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = '/opco/internal/users/auth/reset-request/';

  return authApiService.POST(uri, {});
};
